import { from, Observable, of, switchMap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import {
  APP_TRACKING_TRANSPARENCY_TOKEN,
  AppTrackingTransparencyProvider,
  Log,
  PLATFORM_TOKEN,
  PlatformProvider
} from '@core';

export class AppTrackingTransparencyStep extends StartupStep {
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly attProvider: AppTrackingTransparencyProvider = inject(APP_TRACKING_TRANSPARENCY_TOKEN);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'AppTrackingTransparencyStep START' });

    if (!this.platformProvider.isiOS) {
      this.logger.log(Log.Startup, { message: 'AppTrackingTransparencyStep SKIPPED (not iOS)' });
      return of(state);
    }

    return from(this.attProvider.requestPermission()).pipe(
      switchMap(() => {
        this.logger.log(Log.Startup, { message: 'AppTrackingTransparencyStep COMPLETED' });
        return of(state);
      })
    );
  }
}
